import React from 'react';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="py-16">
      <div className="container-custom">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="section-title">Hakkımızda</h2>
          <p className="text-gray-700 mb-6">
            Cihangir Nakliyat olarak yıllardır güvenilir hizmet sunuyoruz. Profesyonel ekibimiz ve modern 
            ekipmanlarımızla, eşyalarınızı güvenle taşıyor, sizin için tüm taşınma sürecini kolaylaştırıyoruz.
          </p>
          <p className="text-gray-700 mb-6">
            Türkiye'nin her noktasına hizmet veriyor, müşteri memnuniyetini ön planda tutuyoruz. Yılların 
            verdiği tecrübeyle, taşınma sürecinizi sorunsuz ve stressiz hale getiriyoruz.
          </p>
          <Link 
            to="/hakkimizda" 
            className="btn-primary inline-block"
          >
            Daha Fazla Bilgi
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 